// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';
import TransactionRellocationLog from '../shared/transaction-reallocation-log';

function ATPTransactionLogPage () {

    return (
        <AuthenticatedPage className="atp-page deere-atp-transaction-log-page">
            <TransactionRellocationLog transactionLog={true} deereAtp={true} />
        </AuthenticatedPage>
    );

}
ATPTransactionLogPage.displayNAme = 'ATPTransactionLogPage';

export default ATPTransactionLogPage;
